// i18n area 'apps' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.hu-HU.meta.json.
import type { enUS } from './apps'

export const huHU: typeof enUS = {

  // Apps wave 1 (Annex R): container podman gestiti — supervisionati dal
  // worker su un nodo dichiarato; immagine = lockfile branch@digest (Annex Q)
  // con policy pinned/tracking; attacco L3 untagged con IP statico.
  apps: {
    title: 'Appok',
    create: 'App létrehozása',
    createTitle: 'App létrehozása',
    editTitle: 'App szerkesztése',
    name: 'Név',
    nameHint: 'DNS-1123, a scope-on belül egyedi — a létrehozás után nem módosítható.',
    node: 'Csomópont',
    nodeHint: 'A tagcsomópont, amely kiszolgálja — explicit elhelyezés (az ütemező később érkezik).',
    image: 'Image',
    editImageHint: 'Egy új hivatkozás újra feloldódik a törzsadatokon keresztül — ez a pin/rollback gesztusa.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'A digest csak parancsra mozdul.',
    policyTrackingHint: 'Automatikus rolling, amikor egy frissítés elmozdítja a branchet.',
    archMovePolicy: 'Cross-arch áthelyezés',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Mi történik, ha az appot másik architektúrájú node-ra HELYEZIK ÁT: a refuse elutasítja az áthelyezést, a reresolve újra feloldja a lockfile-t a branchből az új archon — a tartalom megváltozik, és a válasz megnevezi a digest változását.',
    network: 'Hálózat',
    networkHint: 'Untagged L3-csatlakozás: egy logikai fabric-hálózat (ajánlott — gateway/DNS az egyetlen forrásából), egy overlay, vagy egy csupasz host-bridge (nem ajánlott).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host-bridge:',
    ipAssignment: 'IP-kiosztás',
    ipStatic: 'Statikus',
    ipAuto: 'Automatikus (IPAM)',
    ipAssignmentHint_static: 'A címet te adod meg, most.',
    ipAssignmentHint_auto: 'Az IPAM választ egy szabad címet a hálózat TVirt számára fenntartott címtartományaiból.',
    bridgeDiscouraged: 'Csupasz host-bridge — NEM AJÁNLOTT: a TVirt semmit sem tud a címzéséről, ezért a gateway-t és a DNS-t kézzel kell megadni. Az ajánlott út egy logikai fabric-hálózat.',
    ip: 'IP',
    ipHint: 'Statikus IPv4 a csatlakozás alhálózatán belül.',
    ipCidrHint: 'CIDR-alakban egy csupasz bridge-en (pl. 192.168.1.10/24) — nincs honnan származtatni a prefixet.',
    gateway: 'Gateway',
    gatewayManualHint: 'Kézi — egy csupasz bridge semmit sem származtat.',
    dnsServers: 'DNS-szerverek',
    dnsManualHint: 'Kézzel, vesszővel elválasztva — legalább egy.',
    rootKind: 'Root',
    rootEphemeral: 'efemer',
    rootPersistent: 'perzisztens',
    rootEphemeralHint: 'Minden újralétrehozáskor az image-ből épül újra; a klaszter efemer tárolóján él.',
    rootEphemeralHintNamed: 'Minden újralétrehozáskor az image-ből épül újra; a klaszter efemer tárolóján él ({name}).',
    rootPersistentHint: 'Túléli az újraindításokat; az általad választott tárolón él.',
    rootStorage: 'Root-tároló',
    editRootStorageHint: 'A root az új készleten renderelődik újra — a meglévő adatok NEM költöznek át maguktól.',
    volumes: 'Kötetek',
    volumeAdd: 'Kötet hozzáadása',
    volumeName: 'Név',
    volumeMountPath: 'Csatolási útvonal',
    volumeKind: 'Típus',
    volumeStorage: 'Tároló',
    devices: 'Eszközök',
    deviceClassHint: 'Egy OSZTÁLYT kérsz (gpu-device vagy usb-device címkét), sosem konkrét eszközt: a megadott csomóponton lennie kell egy Appokhoz megjelöltnek. Több App is használhatja ugyanazt az eszközt — a konténer megosztja, nem veszi el a gazdagéptől.',
    deviceSlot: 'Slot',
    deviceTag: 'Címke',
    deviceValue: 'Osztály',
    deviceUnresolved: 'most semmi sem oldódik fel',
    noDeviceTags: 'Még nincs gpu-device vagy usb-device fajtájú címke: hozz létre egyet, és rendeld az Appokhoz megjelölt eszközökhöz.',
    env: 'Környezet',
    envHint: 'Soronként egy KULCS=érték.',
    secretEnvTitle: 'Titkos változók',
    secretEnvNotice: 'Egy titkos érték soha többé nem jön vissza az API-ból: senki nem olvassa el újra, még az sem, aki beírta. A checkpointban a masterpass-szal lepecsételve utazik, így egy masterpass nélküli visszaállítás újbóli beírását kéri.',
    secretEnvPromote: 'Tegyél titkossá egyet a fent beírt változók közül:',
    secretEnvAdd: 'Titkos változó hozzáadása',
    secretEnvName: 'Név',
    secretEnvValue: 'Érték',
    secretEnvKept: 'megőrizve — hagyd üresen, hogy változatlan maradjon',
    secretEnvWithdrawWarning: 'Ha egy már titkos változót nem akarsz többé titkosként kezelni, írj neki új értéket: a jelölés puszta levétele mód lenne arra, hogy ELOLVASD azt, ami a store-ból soha nem jön ki. Az eltávolítása ezzel szemben törli.',
    secretEnvChip: 'titkos',
    startNow: 'Indítás azonnal (különben az app leállítva születik)',
    deletePersistentIntro: 'Ennek az appnak perzisztens adatai vannak — döntsd el, mi legyen velük:',
    deleteKeepData: 'Adatok megtartása (a könyvtárak árván a tárolóikon maradnak)',
    deletePurgeData: 'Az adatok törlése is',
    phase: 'Fázis',
    phase_running: 'Fut',
    phase_stopped: 'Leállítva',
    phase_error: 'Hiba',
    phase_unknown: 'Ismeretlen',
    desiredState: 'Kívánt',
    wantedRunning: 'fut',
    wantedStopped: 'leállítva',
    start: 'Indítás',
    stop: 'Leállítás',
    restart: 'Újraindítás',
    refreshImage: 'Image frissítése (az új @current átvétele)',
    logs: 'Napló',
    logsTitle: 'Napló',
    logsEmpty: 'Nincs elkapott kimenet.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Az App nem fut — egy shellhez élő konténer kell. A logjai bármilyen állapotban olvashatók.',
    shellConnect: 'Csatlakozás',
    shellDisconnect: 'Leválasztás',
    shellExited: 'A munkamenet {code} kilépési kóddal ért véget.',
    shellEndedWithoutStatus: 'A munkamenet kilépési állapot nélkül ért véget: {reason}',
    shellRevoked: 'A munkamenet ticketje már nem érvényes — lejárt, vagy a bejelentkezést, amely megnyitotta, visszavonták.',
    shellHint: 'Kattints a fekete mezőbe és gépelj: a billentyűk a konténerhez jutnak. A Ctrl+C és a nyilak működnek; az exit bezárja a shellt.',
    shellStatus: {
      connecting: 'Csatlakozás…',
      connected: 'Csatlakozva',
      ended: 'Véget ért'
    },
    deleteRunningError: 'A(z) {name} kívánt állapota futó — előbb állítsd le.',

    // Dialog standard (round #156): i tab del dettaglio e i campi contract
    // mancanti — ogni campo dell'App visibile, lucchetti col perché.
    tabs: {
      general: 'Általános',
      image: 'Image',
      network: 'Hálózat',
      storage: 'Tároló',
      devices: 'Eszközök',
      observed: 'Megfigyelt'
    },
    attachment: 'Csatlakozás',
    runningDigest: 'Futó digest',
    lastError: 'Utolsó hiba',
    reportObservedAt: 'A worker utolsó jelentése',
    desiredStateLock: 'Az Indítás/Leállítás műveletek kormányozzák — sosem közvetlen módosítás.',
    ipEditDisabledHint: 'Csak statikus kiosztásnál módosítható.',
    derivedFromNetworkHint: 'A hálózat egyetlen forrásából származtatva — kézi csak csupasz bridge-en, statikus IP-vel.',
    ephemeralUnset: 'nincs beállítva',
    ephemeralMissing: 'Az Appok efemer tárolója nincs beállítva — efemer részekkel (root vagy kötetek) rendelkező app létrehozása elutasításra kerül, amíg be nem állítod.',
    ephemeralCurrent: 'Az Appok efemer tárolója: {name}',
    ephemeralMissingCreate: 'Ennek az appnak efemer részei vannak, de az Appok efemer tárolója nincs beállítva — a létrehozás el lesz utasítva. Állítsd be előbb az Appok oldal bannerjéből.',
    setEphemeral: 'Efemer tároló beállítása',
    changeEphemeral: 'Efemer tároló módosítása',
    setEphemeralTitle: 'Az Appok efemer tárolójának beállítása',
    changeEphemeralTitle: 'Az Appok efemer tárolójának módosítása',
    ephemeralStorageHint: 'Klaszterszintű DEFAULT: a dir-jellegű készlet, ahol minden app rootja és efemer kötetei élnek, hacsak az app nem deklarál felülbírálást. A módosítás nem menet közbeni, és semmit sem indít újra: az egyes appok következő indításától érvényes — az efemer adatok nem költöznek.',
    ephemeralPool: 'Tárolókészlet',
    ephemeralOverride: 'Efemer tároló (appONkénti felülbírálás)',
    ephemeralOverrideInherit: 'A klaszter defaultjának öröklése',
    ephemeralOverrideInheritNamed: 'A klaszter defaultjának öröklése ({name})',
    ephemeralOverrideHint: 'Apponkénti készlet a roothoz és az efemer kötetekhez — hagyd üresen a klaszter defaultjának örökléséhez. A módosítás nem menet közbeni, és semmit sem indít újra: a következő indítástól érvényes (az efemer adatok üresen születnek újjá az új készleten), és az app.ephemeralStorage.set engedélyt igényli.',
    ephemeralOverrideTag: 'felülbírálás',

    imageAnyBranch: 'Minden ág',
    imageBranchHint: 'Az ág által megnevezett képfájlokra szűkít; ág nélkül a repository összes képfájlja látszik.',
    imageDigestHint: 'A tartalom: a digestek táblájából választható, amely a származását és az architektúráját is hozza. Ugyanaz az ág architektúránként egyet kínál, és ezek nem cserélhetők fel.',
    imageLockfile: 'Feloldott hivatkozás',
    imageNoImages: 'Ehhez a repositoryhoz nincs képfájl a gyorsítótárban — tölts le egyet az OCI képfájlok közül.',
    imageHeadNotCached: 'nincs a cache-ben — indításkor letöltődik',
    imageNoRegistries: 'Nincs regisztrált repository: regisztrálj egyet, hogy képfájlt választhass.',
    imageChosenHint: 'A képfájlt a szerkesztő ablak kaszkádjából választod: a hivatkozást soha nem kell begépelni.',
    registerRepositoryHint: 'A regisztrálás nem tölt le semmit: megfigyelhetővé tesz egy repositoryt, hogy a képfájl e párbeszédablak elhagyása nélkül választható legyen.',
    registerRepositoryBranchHint: 'Nem kötelező: az első megfigyelendő ág (pl. latest).',
    registerRepositoryElsewhere: 'A keresett repository nincs regisztrálva: a regisztrálás az OCI képfájlok szakaszban történik, olyasvalaki által, akinek van rá jogosultsága.'
  },

  // Template CT (round K2 #63): gli oggetti CT MATERIALIZZATI — l'import da
  // catalogo è l'unico ingresso; i file si caricano dentro i cataloghi.
  cts: {
    createAction: 'CT létrehozása',
    createTitle: 'Konténer létrehozása sablonból',
    createError: 'A konténer nem jött létre',
    template: 'CT-sablon',
    noTemplates: 'Nincs CT-sablon — importálj egyet a CT-sablonok oldalról',
    resources: 'Erőforrások',
    node: 'Csomópont',
    phase: {
      defined: 'Még sosem indult',
      materializing: 'Materializálódik',
      ready: 'Kész',
      starting: 'Indul',
      running: 'Fut',
      stopping: 'Leáll',
      stopped: 'Leállítva',
      deleting: 'Törlés alatt',
      error: 'Hibaállapotban'
    },
    actions: {
      start: 'Indítás',
      stop: 'Leállítás',
      restart: 'Újraindítás',
      markTemplate: 'Előléptetés CT-sablonná',
      error: 'A rendszer elutasította a műveletet'
    },
    markTemplate: {
      confirmTitle: "Legyen '{name}' CT-sablon?",
      confirmBody: 'A konténer elhagyja ezt a listát, és átkerül a CT-sablonok közé, azonnal készen új CT-k létrehozására. A metaadatok módosíthatók maradnak, és bármikor visszaminősítheted CT-vé.',
      confirm: 'Előléptetés',
      moved: "A(z) '{name}' mostantól CT-sablon — a CT-sablonok között találod."
    },
    stopCause: {
      api: 'A TVirt állította le',
      'ct-exit': 'A konténer magától lépett ki',
      'host-reboot': 'A csomópont újraindításával halt meg',
      'start-failed': 'Az indítás nem sikerült — a feladat hibája megmondja, mi hiányzik és hogyan javítható'
    },

    console: 'Konzol',
    consoleUnavailable: 'A konténer nem fut — a konzolhoz élő konténer kell. A naplója viszont bármilyen állapotban olvasható.',
    consoleNoTemplate: 'A sablon soha nem fut, így nincs konzolja: hozz létre belőle CT-t, és annak a konzolját nyisd meg.',
    consoleConnect: 'Kapcsolódás',
    consoleDisconnect: 'Kapcsolat bontása',
    consoleReconnect: 'Újrakapcsolódás',
    consoleTakenBy: 'Ezt a konzolt átvette egy másik operátor ({user}). Konténerenként egy konzol: az újrakapcsolódás visszaveszi.',
    consoleHint: 'Kattints a fekete területre és írj: a billentyűk eljutnak a konténerbe. A Ctrl+C és a nyilak működnek.',
    consoleEndpointDown: 'A konzol hozzáférési pontja nem nyitható meg a containert kiszolgáló node-on: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'A container nem fut — a shellhez élő container kell. A logjai bármilyen állapotban olvashatók.',
    shellNoTemplate: 'Egy template sosem fut, így nincs shellje: hozz létre belőle egy CT-t, és nyisd meg annak a shelljét.',
    shellConnect: 'Csatlakozás',
    shellDisconnect: 'Leválasztás',
    shellExited: 'A munkamenet {code} kilépési kóddal ért véget.',
    shellEndedWithoutStatus: 'A munkamenet kilépési állapot nélkül ért véget: {reason}',
    shellRevoked: 'A munkamenet ticketje már nem érvényes — lejárt, vagy a bejelentkezést, amely megnyitotta, visszavonták.',
    shellHint: 'Kattints a fekete mezőbe és gépelj: a billentyűk a konténerhez jutnak. A Ctrl+C és a nyilak működnek; az exit bezárja a shellt.',
    shellStatus: {
      connecting: 'Csatlakozás…',
      connected: 'Csatlakozva',
      ended: 'Véget ért'
    },
    rootPassword: 'Root jelszó',
    rootPasswordHint: 'Egyszer íródik be a lemásolt rootfs-be (hashként, többé nem jelenik meg). A disztribúciók image-ei nem tartalmaznak root jelszót: nélküle a shell az egyetlen bejárat.',
    sshKeys: 'A root nyilvános SSH-kulcsai',
    sshKeysHint: 'Soronként egy nyilvános OpenSSH-kulcs, a root/.ssh/authorized_keys fájlba.',
    consoleStatus: {
      connecting: 'Kapcsolódás…',
      connected: 'Kapcsolódva',
      reconnecting: 'Újrakapcsolódás…'
    },
    logs: 'Napló',
    logsTitle: 'Napló',
    logsEmpty: 'Nincs elkapott kimenet.',
    logsSource: 'Melyik napló',
    logsSourceConsole: 'A konténer initjének konzolja — miért nem indult el a benne lévő szolgáltatás',
    logsSourceSupervisor: 'A liblxc felügyelő — miért nem jutott el a konténer odáig, hogy fusson',
    logsNeverStarted: 'Soha nem indították el, így még semmi sincs feljegyezve — indítsd el, és a napló akkor is meglesz, ha az indítás elbukik.',
    logsNoTemplate: 'A sablon soha nem fut, így soha semmit nem jegyzett fel.',
    logsError: 'A naplót nem sikerült elkapni',

    // Dialog standard (round #156): i tab del dettaglio condivisi dalle
    // liste CT e Template CT, più i lucchetti col perché.
    tabs: {
      general: 'Általános',
      hardware: 'Hardver',
      network: 'Hálózat',
      provenance: 'Eredet'
    },
    templateFlag: 'CT-sablon',
    templateLock: 'Csak az Előléptetés / Vissza CT-vé műveletekkel változik — sosem közvetlen módosítással.',
    sourceLock: 'Eredet, a születéskor rögzítve — sosem íródik át; egy halott forrás csupasz hivatkozást hagy.',
    storageLock: 'A létrehozáskor rögzül — a rootfs áthelyezése egy jövőbeli kör.',
    startedAt: 'Elindítva',
    lastStop: 'Utolsó leállás',
    editNicsTitle: 'Hálózatok szerkesztése',
    nicDisconnected: 'lecsatlakoztatva'
  },
  ctTemplates: {
    title: 'CT-sablonok',
    importAction: 'Importálás katalógusból',
    importTitle: 'CT-sablon importálása a katalógusból',
    importSubmit: 'Importálás',
    importError: 'Az importálás el lett utasítva',
    importHint: 'A materializálás a kiválasztott tárolóra másolja a rootfs-t — a katalógusfájl érintetlen marad. Új fájlok hozzáadásához előbb töltsd fel őket egy katalógusba.',
    sourceFile: 'CT-sablonfájl',
    sourceFileHint: 'A kiválasztott katalógus ct-rootfs fájljai, csak a készek',
    noFiles: 'Ebben a katalógusban nincs kész ct-rootfs fájl — tölts fel egyet a katalógus oldaláról',
    source: 'Forrásfájl',
    rootfsStorage: 'A rootfs tárolója',
    rootfsStorageHint: "Ahol a kibontott rootfs-fa él — egy fájlrendszeres tároló, elegendő szabad hellyel a kibontott mérethez plusz körülbelül 1 GiB ráhagyáshoz (különben az importálás meghiúsul).",
    resources: 'Erőforrások',
    cores: 'vCPU',
    memoryMiB: 'Memória (MiB)',
    cpuLimit: 'CPU-korlát',
    cpuLimitHint: 'Host-magokban kifejezve (pl. 1.5); üresen = korlátlan',
    cpuUncapped: 'korlátlan',
    cpuWeight: 'CPU-súly',
    hostname: 'Hostnév',
    hostnameHint: 'Üresen = a CT neve',
    nameservers: 'DNS-névszerverek',
    dnsHint: 'Vesszővel elválasztva; üresen = a host beállításait örökli',
    searchDomains: 'DNS-keresési tartományok',
    dnsInherited: 'A hosttól örökölve',
    networks: 'Hálózatok',
    nicSlot: 'NIC-slot',
    phase: {
      materializing: 'Materializálódik',
      ready: 'Kész',
      deleting: 'Törlés alatt',
      error: 'Hiba'
    },
    exportAction: 'Exportálás a katalógusba',
    exportTitle: 'Exportálás a katalógusba',
    exportSubmit: 'Exportálás',
    exportError: 'Az exportálás el lett utasítva',
    exportHint: 'A materializált rootfs-t egy ÚJ ct-rootfs fájlba csomagolja a kiválasztott katalógusban — a sablon érintetlen marad.',
    exportName: 'A fájl neve',
    exportNameHint: 'Üresen = <template>-export-<n>',
    markCt: {
      action: 'Vissza CT-vé',
      confirmTitle: "Legyen '{name}' újra CT?",
      confirmBody: 'A sablon elhagyja ezt a listát, és visszakerül a CT-listába, újra indíthatóan. Amíg újra elő nem lépteted, nem hozható létre belőle CT.',
      confirm: 'Vissza CT-vé',
      moved: "A(z) '{name}' újra CT — a CT-listában találod."
    }
  },

  // OCI wave 1 (Annex Q — il modello tag-come-branch): un tag OCI è un branch
  // (puntatore mobile), il digest è il commit; refresh = "git fetch",
  // pull = risolvi ADESSO, scarica QUEL digest.
  oci: {
    registriesTitle: 'OCI-registry-k',
    imagesTitle: 'OCI-image-ek',
    provider: 'Szolgáltató',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Általános',
    providerImmutableHint: 'A szolgáltató a létrehozás után nem módosítható — egy másik szolgáltató új registry-t jelent.',
    url: 'URL',
    urlHintPreset: 'A szolgáltató alapján előre kitöltve — csak mirrorokhoz írd felül.',
    urlHintRequired: 'Általános registry-knél kötelező: a https:// alap-URL.',
    urlHintEcr: 'Kötelező: az ECR-végpontok fiókonként/régiónként külön léteznek — nincs preset.',
    credential: 'Hitelesítő adat',
    credentialNone: 'Névtelen hozzáférés',
    credentialHint: 'Egy felhasználó-és-jelszó keystore-bejegyzés; a workerek a használat pillanatában oldják fel — sosem csomóponti auth fájl.',
    nameHint: 'Host-szerű név (docker.io, registry.intra); scope-onként egyedi, nem módosítható',
    addRegistry: 'Registry hozzáadása',
    addRegistryTitle: 'OCI-registry hozzáadása',
    verify: 'Ellenőrzés',
    verifyState: 'Ellenőrzés',
    verified: 'Ellenőrizve',
    verifyFailed: 'Sikertelen',
    neverVerified: 'Még sosem ellenőrizve',
    registryInUseError: "A(z) '{name}' registry-nek még vannak regisztrált repository-jai — előbb töröld őket.",
    repositories: 'Repository-k',
    repositoriesHint: 'A regisztrálás megfigyeli a brancheket (OCI-tageket) — semmit nem tölt le. A frissítés minden megfigyelt branchet felold, és vezeti a reflogot.',
    noRepositories: 'Ezen a registry-n nincs regisztrált repository.',
    registerRepository: 'Repository regisztrálása',
    repoPath: 'Útvonal',
    repoPathHint: "A repository útvonala a registry-n, pl. 'example' vagy 'library/nginx'",
    branches: 'Branchek',
    branchesHint: 'Megfigyelt branchek (OCI-tagek), vesszővel elválasztva — pl. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'MOST feloldva: a pull azt a digestet tölti le, amelyre a branch ma mutat.',
    refresh: 'Frissítés',
    deleteRepository: 'Repository törlése',
    reflogCount: '{n} korábbi',
    noResolutions: 'Még sosem frissült — nincs megfigyelt feloldás.',
    refreshFailed: 'Az utolsó frissítés sikertelen ({when})',
    loadError: 'A repository-k nem tölthetők be.',
    reference: 'Hivatkozás',
    digest: 'Digest',
    digestHint: 'sha256:… — a pontos image, branch nélkül (detached)',
    size: 'Méret',
    nodes: 'Csomópontok',
    detached: 'detached',
    detachedHint: 'Digest szerint letöltve, branch nélkül — a drift-ellenőrzés nem érvényes rá.',
    pulledAt: 'Letöltve',
    pull: 'Pull',
    pullTitle: 'Image pullolása',
    pullHint: 'Előmelegítés, sosem előfeltétel: a branch szerinti pull MOST old fel, és AZT a digestet tölti le; a digest szerinti pull detached.',
    pullError: 'A pull el lett utasítva',
    pullMode: 'Pull e szerint:',
    pullModeBranch: 'Branch (feloldás most)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Az őszinte default: mint az apt install — később újra futtatva más image-et adhat.',
    pullModeDigestHint: 'Pontos digest — reprodukálhatóság és rollback; lemond a drift-ellenőrzésről.',

    // Il pattern a due pulsanti (#88, ratifica 2026-07-30 sera): "da
    // registry" è il pull guidato esistente, "da catalogo" materializza un
    // archivio oci-image pronto (la via air-gapped).
    importFromRegistry: 'Importálás registry-ből',
    importFromCatalog: 'Importálás katalógusból',
    importCatalogTitle: 'OCI-image importálása katalógusból',
    importCatalogHint: 'Az air-gapped út: egy kész oci-image archívum (tar/tar.gz — docker-archive vagy oci-archive) materializálódik az image-store-ban a catalog/<catalogo>/<file>@<digest> hivatkozással; az appok úgy fogyasztják, mint bármely más image-et. Az archívumokat a katalógusokba kell feltölteni — ez a szekció csak importál.',
    importCatalogFile: 'Archívum',
    importCatalogFileHint: 'A kiválasztott katalógus kész oci-image fájljai.',
    importCatalogNoFiles: 'Ebben a katalógusban nincs kész oci-image archívum — tölts fel egyet a katalógus részleteiből.',
    importCatalogError: 'Az importálás el lett utasítva',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'A klaszter OCI-gyorsítótára nincs beállítva — a pullok el lesznek utasítva, amíg be nem állítasz egy tárolókészletet.',
    setCache: 'Gyorsítótár beállítása',
    setCacheTitle: 'Az OCI-gyorsítótár beállítása',
    setCacheHint: 'A klaszterszintű DEFAULT készlet, amely a letöltött image-ek blobjait tárolja — egy scope felülbírálhatja a saját készletével (Scope oldal). A módosítás nem menet közbeni, semmit sem indít újra, és nem mozgatja a blobokat: azok lazy módon jelennek meg újra a következő indításkor/használatkor.',
    cachePool: 'Tárolókészlet',
    changeCache: 'Gyorsítótár módosítása',
    changeCacheTitle: 'Az OCI-gyorsítótár készletének módosítása',
    cacheCurrent: 'A klaszter OCI-gyorsítótára (default): {name}',
    sectionOverview: 'Áttekintés',
    sectionRepositories: 'Repository-k',
    sectionExplore: 'Felfedezés',
    exploreHint: 'Élő távoli keresés a registry-n — Docker Hubon teljes (leírás, letöltések, csillagok), más szolgáltatóknál best-effort. Válassz ki egy találatot a teljes leírásához és a távoli tagek böngészéséhez; egy tagből hozzáadhatod a hivatkozást egy TVirt-repositoryhoz.',
    exploreSearch: 'Keresés',
    exploreUnsupported: 'Ez a szolgáltató nem támogatja a keresést.',
    exploreNoResult: 'Nincs egyező repository.',
    exploreNoTags: 'Nincs egyező tag ezen a repositoryn.',
    exploreOfficial: 'Hivatalos',
    explorePulls: 'Letöltések',
    exploreStars: 'Csillagok',
    exploreUpdated: 'Frissítve {when}',
    exploreLoadMore: 'Továbbiak betöltése',
    exploreSelectHint: 'Válassz ki egy találatot: a teljes leírás és a távoli tagek itt töltődnek be.',
    exploreNoDescription: 'Ettől a szolgáltatótól nem érhető el leírás.',
    exploreTagsTitle: 'Távoli tagek',
    exploreTagFilter: 'Tag keresése',
    exploreAddToRepo: 'Hozzáadás repositoryhoz',
    exploreAdded: 'A(z) {path}:{tag} mostantól követve van — lásd a Repository-k szekciót.',
    addBranch: 'Branch hozzáadása',
    purgeRequiredTitle: "Törlöd a(z) '{name}' repository-t az image-eivel együtt?",
    purgeRequiredBody: 'Egyetlen app sem fogyasztja ezt a repository-t, de még léteznek letöltött image-ek: a törlés a rekordjaikat is eltávolítja, a gyorsítótárazott blobok pedig a garbage collectorra maradnak.',
    purgeConfirm: 'Az image-ek törlése is',
    providerSelectHint: 'Válaszd ki a registry típusát: a kártya elmondja a preseteket és a használatot.',
    providerDesc: {
      dockerhub: 'A nyilvános Docker registry: előre kitöltött URL, teljes keresés leírásokkal és számlálókkal.',
      ghcr: 'GitHub Container Registry: előre kitöltött URL; a fiókok personal access tokent használnak.',
      ecr: 'Amazon Elastic Container Registry: fiókonkénti/régiónkénti végpontok — az URL-t meg kell adni.',
      quay: 'A Red Hat Quay registry: előre kitöltött URL.',
      generic: 'Self-hosted registry (Harbor, registry:2, …): a https:// URL kötelező.'
    },

    // Dialog standard (round #156): i campi del dettaglio immagine/registry
    // che le colonne non mostravano.
    layerCount: 'Rétegek',
    verifiedAt: 'Utolsó ellenőrzés',
    verifyOk: 'Eredmény',
    verifyMessage: 'Ellenőrzési üzenet',

    // A #348/R39 modell: a képfájl MAGA a digest — a tartalom —, a registry, a repository és az ág pedig a NEVEK, amelyek elérik.
    head: 'Head',
    heads: 'Fejek architektúránként',
    listDigest: 'A lista digestje',
    neverResolved: 'Még sosem feloldva',
    totalSize: 'Teljes méret',
    reflogTitle: 'A feloldások története',
    usedBy: 'Használja',
    usageLockfile: 'lockfile',
    usageRunning: 'fut',
    evictable: 'eltávolítható',
    evict: 'Eltávolítás a gyorsítótárból',
    evictHeadTitle: 'Eltávolítod a gyorsítótárból: {digest}?',
    evictHeadBody: 'Ez legalább egy gyűjtő aktuális feloldása: az eltávolítása jogos — csak gyorsítótár, a távoli branch továbbra is kiszolgálja —, de nem történhet véletlenül. A blob EGY van: az eltávolítás minden gyűjtőt kiürít, amely osztozik rajta.',
    evictConfirm: 'Eltávolítás mindenképp',

    arch: 'Architektúra',
    names: 'Nevek',
    noNames: 'nincs név',
    views: 'Nézetek',
    lastView: 'utolsó nézet',
    evictLastViewTitle: 'Eltávolítod az utolsó hivatkozást erre: {digest}?',
    evictLastViewBody: 'Ez a tartalom utolsó nézete: eltávolításával a képfájl megszűnik létezni a TVirtben, és a bájtok ({size}) felszabadulnak. Ez a modell docker image rm-je — nem mellékhatás, hanem maga a művelet.',
    branchesTabHint: 'E repository megfigyelt ágai: mindegyiknél a mai fejek — architektúránként egy — a frissítések kronológiája és hogy az általa megnevezett képfájlokból hány van a gyorsítótárban. A frissítés a repository «git fetch»-e: egy lépésben feloldja az összes ágát.',
    noBranches: 'Ezen a repositoryn egyetlen ág sincs megfigyelve.',
    stopObserving: 'Ág megfigyelésének befejezése',
    pullBranch: 'A branch fejének letöltése a cache-be (a refresh feloldja, ez letölti)',
    pullDigest: 'Ennek a digestnek a letöltése a cache-be',
    imageCount: 'Képfájlok',
    deleteBranchPurgeTitle: 'Név nélkül maradjanak a(z) {name} képfájljai?',
    deleteBranchPurgeBody: 'Egyetlen alkalmazás sem nevezi meg ezt az ágat, de néhány képfájl csak rajta keresztül érhető el: törlésével név nélkül maradnak a gyorsítótárban, a repository képfájljai közt felsorolva, kézzel eltávolíthatóan.',
    deleteBranchPurgeConfirm: 'Törlés, a képfájlok név nélkül maradnak',
    imagesTabHint: 'E repository képfájljai — a tartalmak, azaz a digestek — ág választása nélkül is láthatók. Egy képfájl fürtönként egyedi: az őt elérő nevekből több is lehet.',
    noImages: 'E repository egyetlen képfájlja sincs a gyorsítótárban materializálva.',
    deleteRepositoryTitle: 'Törlöd: {name}?',
    deleteRepositoryBody: 'A repository és ágai eltűnnek a kronológiájukkal együtt. A képfájlok a gyorsítótárban maradnak: csak ezt a nevet veszítik el. Alkalmazás által megnevezett repository nem törölhető.',
    provenanceCatalog: 'katalógus',
    refreshedAt: 'Frissítve',
    neverRefreshed: 'Soha nem frissült',
    sectionBranches: 'Ágak',
    sectionImages: 'Képfájlok',
    repositoriesGovernedElsewhere: 'Itt a repositorykat csak nézni lehet: regisztrálásuk, frissítésük, ágaik megfigyelése és képfájljaik eltávolítása az OCI képfájlok szakaszban történik.',
    gotoImages: 'Ugrás az OCI képfájlokhoz'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Podok',
    containers: 'Konténerek',
    instances: 'Példányok',
    instancesTooltip: '{running} fut, {error} hibás',
    placement: 'Elhelyezés',
    spread: 'elosztás',
    ha: 'HA',
    templateRevision: 'revízió',
    deleting: 'Törlés alatt',
    empty: 'Nincs pod — hozzon létre egy appot (egy konténer) vagy egy podot a CLI-ből (create-pod).',
    openInstances: 'Példányok megnyitása',
    rollingRestart: 'Gördülő újraindítás',
    scale: 'Skálázás',
    scaleTitle: '{name} skálázása',
    scaleHint: 'Példányok száma (0–64): felfelé a legalacsonyabb szabad sorszám születik, lefelé a legmagasabb vonul vissza, tartós adatai megmaradnak.',
    scaleError: 'A skálázás nem sikerült',
    replicas: 'Replikák',
    deleteRunningError: 'A(z) {name} fut — előbb állítsa le.',
    deleteInstancesIntro: 'Mind a {count} példány eltávolításra kerül.',
    stateRunning: 'Fut',
    stateStopped: 'Leállítva',
    editor: {
      createTitle: 'Pod létrehozása',
      create: 'Pod létrehozása',
      editTitle: 'Pod szerkesztése',
      nameHint: 'DNS-1123, legfeljebb 58 karakter — a példányok neve <név>-<index>; létrehozás után nem módosítható.',
      restartPolicy: 'Újraindítási szabály',
      restartPolicyHint_always: 'A csomópont minden kilépett konténert újraindít, exponenciális várakozással (10 s → 5 perc).',
      restartPolicyHint_onFailure: 'Csak a nem nulla kóddal kilépett konténer indul újra; a 0-s kilépés nyugalomban marad.',
      restartPolicyHint_never: 'A kilépett konténer marad, ahogy van — a példány succeeded vagy failed állapotban végződik.',
      grace: 'Türelmi idő (s)',
      graceHint: 'A leállítás SIGTERM → SIGKILL korlátja.',
      hostname: 'Gépnév',
      hostnameHint: 'Üres = a példány neve.',
      hostnameDefault: 'a példány neve',
      sharePid: 'PID névtér megosztása a konténerek között',
      containersIntro: 'Az init konténerek sorban, végig lefutnak a konténerek indulása előtt; a konténerek a példány hálózatát osztják meg (egy IP, localhost egymás között).',
      initContainers: 'Init konténerek',
      initAdd: 'Init konténer hozzáadása',
      initHint: 'Mindegyiknek 0-val kell kilépnie; egy hiba a példányt hibába viszi, a csomópont várakozással újrapróbálja.',
      containerAdd: 'Konténer hozzáadása',
      atLeastOne: 'Egy Podhoz legalább egy konténer kell.',
      duplicateNames: 'A konténernevek egyediek legyenek a Podon belül (init konténerekkel együtt).',
      containerName: 'Konténer neve',
      containerInvalid: 'Ez a konténer hiányos: név (DNS-1123), kép, csatolások deklarált kötetekre, számszerű korlátok és próba.',
      command: 'Parancs',
      commandHint: 'Felülírja a kép entrypointját — soronként egy argumentum, soha nem shell-sztring.',
      args: 'Argumentumok',
      argsHint: 'Soronként egy (üresen a kép CMD-je).',
      mounts: 'Csatolások',
      mountAdd: 'Csatolás hozzáadása',
      mountNoVolumes: 'Előbb deklaráljon egy kötetet a Tárhely lapon.',
      readOnly: 'csak olvasható',
      resources: 'Korlátok',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (pl. 1.5)',
      memory: 'Memória (MiB)',
      memoryHint: 'podman --memory',
      health: 'Életjel-próba',
      healthCmd: 'Próba parancsa',
      healthCmdHint: 'A csomópont minden felügyeleti ütemben lefuttatja a konténerben — soronként egy argumentum; 0-s kilépés = egészséges.',
      healthTimeout: 'Időkorlát (s)',
      healthRetries: 'Próbálkozások',
      healthRetriesHint: 'Egymást követő hibák, mielőtt a csomópont újraindítja a konténert.',
      ips: 'Statikus címek',
      ipsHint: 'Példányonként egy, sorszám szerint — a listán túli skálázás elutasításra kerül.',
      instance: 'példány',
      volumesHint: 'A kötetek a Podé; a csatolási útvonal az egyes konténereké (Konténerek lap).',
      spread: 'Szétosztás',
      spreadHint_preferred: 'Példányok különböző csomópontokon, ha lehet.',
      spreadHint_required: 'Példányok különböző csomópontokon, különben a skálázás elutasít.',
      spreadHint_none: 'Csak a döntéshozó.',
      ha: 'Magas rendelkezésre állás (opt-in)',
      haHint: 'Minden tartós darab megosztott storage-on; ha a csomópont meghal, a HA decider újra létrehozza a példányokat egy másik tagon (automatikus failover, mint a HA VM-eknél).',
      yes: 'igen',
      no: 'nem'
    },
    detail: {
      container: 'Konténer',
      actions: 'Műveletek',
      ready: 'Kész',
      notReady: 'Nem kész',
      restarts: 'Újraindítások',
      lastRestartAt: 'Utolsó újraindítás:',
      backoffUntil: 'Újrapróbálás:',
      stateAbsent: 'hiányzik',
      stateRunning: 'fut',
      stateTerminated: 'befejeződött',
      stateWaiting: 'várakozik',
      init: 'init',
      noInstances: 'Nincs példány (replikák: 0).',
      ha: 'HA',
      haHint: 'Automatikus failover: ha a csomópont meghal, a HA decider újra létrehozza a példányt egy másik tagon (minden tartós darab megosztott storage-on).',
      authority: 'Authority (csomópont)',
      homeless: 'authority nélkül',
      homelessHint: 'A checkpointból való visszaállítás kihagyja az authorityt (#380): egyetlen csomópont sem szolgálja ki, amíg nem skálázza a Podot (akár ugyanannyi replikára).',
      restartContainer: 'Csak ezt a konténert indítsa újra (a pod fent marad)',
      divergingHint: 'E példány kívánt állapota eltér a Pod alapértelmezésétől (PD-P19).',
      revisionLag: '{applied}. revízió alkalmazva a(z) {current}. helyett',
      updatedInstances: '{updated}/{desired} példány ezen a revízión'
    }
  }
}
